module.exports = "footer {\n  bottom: 0;\n  left: 0;\n  position: relative;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.scss
// module id = ./src/app/shared/footer/footer.component.scss
// module chunks = main